import { LegalPage, LEGAL } from "@/components/LegalPage";

const sections = [
  { h: "What we collect", p: [
    "Account details: your name, email address and password (stored only as a secure hash), or your basic Google profile if you sign in with Google.",
    "Case information you choose to save: charges, jurisdiction, court dates, notes, diagnostic answers and AI companion conversations.",
    "Consult requests you send to attorneys, including the contact details and message you include.",
    "For attorneys: profile details, bar and practice information, and membership status.",
  ]},
  { h: "How we use it", p: [
    "To run your private case vault, show court-date countdowns and reminders, generate AI companion responses, and deliver consult requests to the attorney you choose.",
    "We do not sell your personal information, and we do not share your saved cases with attorneys unless you send them a consult request.",
  ]},
  { h: "Service providers", p: [
    "Payments are handled by Stripe, which receives your payment details directly. AI companion messages are processed by our AI model provider to generate replies. Sign-in with Google is handled by Google. These providers only receive what they need to perform their service.",
  ]},
  { h: "Sensitive information", p: [
    "Information about criminal matters is sensitive. Only save what you're comfortable storing, and remember that conversations with SentinelGuide are not protected by attorney-client privilege.",
  ]},
  { h: "Security and retention", p: [
    "We use encrypted connections, hashed passwords and access controls so only you can view your vault. We keep your data while your account is active. You can delete individual cases anytime and request full account deletion by emailing us.",
  ]},
  { h: "Your rights", p: [
    `Depending on where you live (for example California), you may have the right to access, correct, delete or export your personal information. Email ${LEGAL.email} and we will respond within the time required by law.`,
  ]},
  { h: "Cookies", p: [
    "We use essential cookies to keep you signed in. We do not use third-party advertising cookies.",
  ]},
  { h: "Children", p: [
    "SentinelGuide is not intended for anyone under 18, and we do not knowingly collect information from children.",
  ]},
];

export default function Privacy() {
  return <LegalPage id="privacy" title="Privacy Policy" sections={sections}
    intro={`This policy explains what ${LEGAL.company} collects, why, and the choices you have.`} />;
}
